<template>
  <div>
    <div class="java110_step">
      <el-steps :active="configMenuInfo.index" finish-status="success" align-center>
        <el-step title="选择菜单组"></el-step>
        <el-step title="菜单信息"></el-step>
        <el-step title="权限信息"></el-step>
      </el-steps>
    </div>

    <!-- 选择应用信息 -->
    <view-menu-group-info 
      v-if="configMenuInfo.index === 0"
      ref="viewMenuGroupInfo"
      @notify="handleNotify">
    </view-menu-group-info>

    <add-menu-view
      v-if="configMenuInfo.index === 1"
      ref="addMenuView"
      @notify="handleNotify">
    </add-menu-view>

    <add-privilege-view
      v-if="configMenuInfo.index === 2"
      ref="addPrivilegeView"
      @notify="handleNotify">
    </add-privilege-view>

    <el-row>
      <el-col :span="20"></el-col>
      <el-col :span="4" style="margin-bottom:10px; text-align:right">
        <el-button type="info" @click="prevStep">
          <span>{{ $t('configMenu.prevStep') }}</span>
        </el-button>
        <el-button 
          v-if="configMenuInfo.index !== 2" 
          type="primary" 
          style="margin-left:10px;"
          @click="nextStep">
          <span>{{ $t('configMenu.nextStep') }}</span>
        </el-button>
        <el-button 
          v-if="configMenuInfo.index === 2" 
          type="primary" 
          style="margin-left:10px;"
          @click="finishStep">
          <span>{{ $t('configMenu.finish') }}</span>
        </el-button>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import ViewMenuGroupInfo from '@/components/dev/viewMenuGroupInfo/viewMenuGroupInfo'
import AddMenuView from '@/components/dev/addMenuView/addMenuView'
import AddPrivilegeView from '@/components/dev/addPrivilegeView/addPrivilegeView'
import { configMenu } from '@/api/dev/menuApi'

export default {
  name: 'ConfigMenu',
  components: {
    ViewMenuGroupInfo,
    AddMenuView,
    AddPrivilegeView
  },
  data() {
    return {
      configMenuInfo: {
        index: 0,
        infos: []
      }
    }
  },
  methods: {
    handleNotify(info) {
      this.configMenuInfo.infos[this.configMenuInfo.index] = info
    },
    prevStep() {
      if (this.configMenuInfo.index > 0) {
        this.configMenuInfo.index--
      }
      this.$refs.viewMenuGroupInfo && this.$refs.viewMenuGroupInfo.onIndex(this.configMenuInfo.index)
      this.$refs.addMenuView && this.$refs.addMenuView.onIndex(this.configMenuInfo.index)
      this.$refs.addPrivilegeView && this.$refs.addPrivilegeView.onIndex(this.configMenuInfo.index)
    },
    nextStep() {
      const currentData = this.configMenuInfo.infos[this.configMenuInfo.index]
      if (!currentData) {
        this.$message.warning(this.$t('configMenu.requiredInfo'))
        return
      }
      if (this.configMenuInfo.index < 2) {
        this.configMenuInfo.index++
      }
      this.$refs.viewMenuGroupInfo && this.$refs.viewMenuGroupInfo.onIndex(this.configMenuInfo.index)
      this.$refs.addMenuView && this.$refs.addMenuView.onIndex(this.configMenuInfo.index)
      this.$refs.addPrivilegeView && this.$refs.addPrivilegeView.onIndex(this.configMenuInfo.index)
    },
    async finishStep() {
      const currentData = this.configMenuInfo.infos[this.configMenuInfo.index]
      if (!currentData) {
        this.$message.warning(this.$t('configMenu.requiredInfo'))
        return
      }
      
      try {
        const param = {
          data: this.configMenuInfo.infos
        }
        await configMenu(param)
        this.$message.success(this.$t('common.success'))
        this.$router.go(-1)
      } catch (error) {
        this.$message.error(error.message || this.$t('common.failed'))
      }
    }
  }
}
</script>

<style scoped>
.java110_step {
  margin-bottom: 20px;
}
.el-row, .el-col {
  width: 100%;
}
</style>